import {events, util, RunConfigService, ConfigService, UrlService, equinoxLocalStorage} from '@nuskin/ns-util';
import { getConfiguration } from '@nuskin/configuration-sdk';

/**
 *
 * LoginService
 *
 * @namespace LoginService
 */
let LoginService = function() {
    let _loginParams = {},
        equinoxEnabledMarket;

    events.subscribe(events.authentication.REQUEST_FOR_LOGIN, function(_params) {
        showLogin(_params);
    });

    events.subscribe(events.authentication.HIDE_LOGIN_POPUP, function() {
        if (window.logInPopup) {
            window.logInPopup.jqmHide();
        }
    });

    events.subscribe(events.authentication.SET_LOGIN_PARAMS, function(_params) {
        _loginParams = _.extend(_loginParams, _params ? _params : {});
    });

    try {
        getConfiguration(['Equinox_Markets']).then(config => {
            if (util.countryCode === config.Equinox_Markets.country_code && config.Equinox_Markets.active) {
                equinoxEnabledMarket = config.Equinox_Markets.country_code;
            }
        });
    } catch (e) {
        console.error(e)
    }

    /**
     * @memberof LoginService
     *
     * @example
     * @param language
     * @returns {string} newLoginUrl
     */
    function getNewLoginUrl(language) {
        let baseNewLoginUrl = '/content/login/corporate/{lang}.html'
        return baseNewLoginUrl.replace('{lang}', language);
    }

    /**
     * @memberof LoginService
     * @example
     * LoginService.showLogin(_params)
     * @param {object} _params
     */
    function showLogin(_params) {
        let loginParams = _.extend({}, _loginParams, _params ? _params : {});
        let legacyLogin = true;
        let baseLoginUrl = '';
        let config = ConfigService.getMarketConfig();

        try {
            // used with toggling between login popup or gigya: id="logInForm" #logInForm (comment added for easer search on id)
            // useGigyaLogin is configuration removed
            // if (typeof(nuskin.configuration.useGigyaLogin) != "undefined" && nuskin.configuration.useGigyaLogin) {
            if (typeof(config) != "undefined" && config.markets !== "TW") {
                if(config.mecSite.useMysiteSignup && config.showWholeSalePricing) {
                    legacyLogin = false;
                    // Make sure it is the AEM locale URL since there are static pages now.
                    window.location = window.location.origin + UrlService.getAemLocaleUrl() + config.mecSite.mysiteMemberSignupPage;
                } else {
                    if (config.useNewSignin) {
                        baseLoginUrl = getNewLoginUrl(util.languageCode);
                    } else {
                        if (config.isMicrosite) {
                            baseLoginUrl = config.gigyaLoginUrl + util.languageCode + '.html';
                        }
                    }

                    let destination = '';
                    let cancelUrl = '';
                    if(typeof(config.isMicrosite) != undefined && config.isMicrosite) {
                        destination = util.Url.encodeParameter(loginParams.href ? loginParams.href : window.location.href);
                    } else {
                        // Get base url because gigya in production will not redirect back to the subdomain for storefront after logging in
                        destination = util.Url.encodeParameter(loginParams.href ? loginParams.href : window.location.pathname);
                        if ((loginParams.href === undefined && window.location.href.indexOf("/static/") > 0) || loginParams.href && loginParams.href.indexOf("http") < 0) {
                            destination = RunConfigService.getBaseUrl() + destination;
                        } else if(loginParams.href === undefined) {
                            throw "use legacy";
                        }
                    }
                    // set cancel url we don't want to go back to the same route because it requires authentication and the user will get stuck in a authentication loop
                    // Go back to app default init route unless cancelUrl is not set
                    if (!loginParams.cancelUrl) {
                        cancelUrl = destination;
                    } else {
                        cancelUrl = util.Url.encodeParameter(loginParams.cancelUrl);
                    }
                    let loginUrlParams = baseLoginUrl + '?destination={destination}&cancel={cancel}';
                    let loginUrl = loginUrlParams.replace('{destination}', destination).replace('{cancel}', cancelUrl);
                    try {
                        if (util.countryCode.length > 0) {
                            loginUrl = loginUrl + '&market=' + util.countryCode;
                        }
                    } catch (e) {}
                    if (config.isMicrosite) {
                        loginUrl = loginUrl + '&isMicrosite=true';
                    }
                    if (util.getLocaleUrl()) {
                        loginUrl += "&localepage=" + util.localePage;
                    }
                    if(loginParams.hideSignup || (equinoxLocalStorage.isEquinoxEnabled() && equinoxEnabledMarket)) {
                        loginUrl += '&hideSignup=true';
                    }
                    legacyLogin = false;
                    window.location = loginUrl;
                }

            }
        }catch(e) {}
        if(legacyLogin){
            if (typeof window.showLoginPopup == 'function') {
                window.showLoginPopup(loginParams);
            } else {
                console.log('Cannot log in at this time');
            }
        }
    }
};

const loginCallback = (runConfig) => {
    if (runConfig && runConfig.clientId) {
        events.unsubscribe(events.global.RUN_CONFIG_CHANGED, loginCallback);
        LoginService();
    }
};

if (RunConfigService.getRunConfig().clientId) {
    LoginService();
} else {
    events.getValue(events.global.RUN_CONFIG_CHANGED, loginCallback, true);
}

export default LoginService;
